export const FLAG_GETTING_PARCELS = 'FLAG_GETTING_PARCELS';
export const GET_PARCELS = 'GET_PARCELS';
export const CLEAR_PARCELS = 'CLEAR_PARCELS';
export const FLAG_GETTING_INCOMES_PARCELS = 'FLAG_GETTING_INCOMES_PARCELS';
export const GET_INCOMES_PARCELS = 'GET_INCOMES_PARCELS';
export const CLEAR_INCOMES_PARCELS = 'CLEAR_INCOMES_PARCELS';
export const FLAG_GETTING_OTHER_INCOMES_PARCELS =
  'FLAG_GETTING_OTHER_INCOMES_PARCELS';
export const GET_OTHER_INCOMES_PARCELS = 'GET_OTHER_INCOMES_PARCELS';
export const CLEAR_OTHER_INCOMES_PARCELS = 'CLEAR_OTHER_INCOMES_PARCELS';
export const FLAG_PARCEL_ACTIVITY = 'FLAG_PARCEL_ACTIVITY';
export const GET_PARCEL = 'GET_PARCEL';
export const CLEAR_PARCEL = 'CLEAR_PARCEL';
export const POST_CARGO_PRICE = 'POST_CARGO_PRICE';
export const CLEAR_CARGO_PRICE = 'CLEAR_CARGO_PRICE';
export const CLEAR_CARGO_PRICES = 'CLEAR_CARGO_PRICES';
export const PRINT_CARGO_VOUCHER_ON_MOUNT = 'PRINT_CARGO_VOUCHER_ON_MOUNT';

export const POST_CARGO_PRICE_BAGGAGE = 'POST_CARGO_PRICE_BAGGAGE';
export const CLEAR_CARGO_PRICE_BAGGAGE = 'CLEAR_CARGO_PRICE_BAGGAGE';
export const FLAG_CARGO_PRICE_BAGGAGE_ACTIVITY = 'FLAG_CARGO_PRICE_BAGGAGE_ACTIVITY';
export const PRINT_CARGO_VOUCHER_STICKER = 'PRINT_CARGO_VOUCHER_STICKER'
